import { render, staticRenderFns } from "./PushModal.vue?vue&type=template&id=6736b86a"
import script from "./PushModal.vue?vue&type=script&lang=js"
export * from "./PushModal.vue?vue&type=script&lang=js"
import style0 from "./PushModal.vue?vue&type=style&index=0&id=6736b86a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports